/**
 * @generated SignedSource<<aae9e027f8ca7afbfd0c5ff787c400ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Header_user$data = {
  readonly createdAt: string;
  readonly birthDayPrivacy: boolean;
  readonly displayName: string;
  readonly profile: {
    readonly age: number | null;
  } | null;
  readonly city: {
    readonly name: string;
    readonly province: {
      readonly shortName: string;
    } | null;
  } | null;
  readonly stats: ReadonlyArray<{
    readonly gamesPlayed: number;
    readonly sport: {
      readonly slug: string;
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
  readonly " $fragmentType": "Header_user";
};
export type Header_user$key = {
  readonly " $data"?: Header_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": 116
        }
      ],
      "kind": "FragmentSpread",
      "name": "Avatar_actor"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "birthDayPrivacy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "age",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "City",
      "kind": "LinkedField",
      "name": "city",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Province",
          "kind": "LinkedField",
          "name": "province",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shortName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSportStat",
      "kind": "LinkedField",
      "name": "stats",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gamesPlayed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Sport",
          "kind": "LinkedField",
          "name": "sport",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "95e45c6d7c8922f8699701b0b44baac7";

export default node;
